<template>
  <BaseExpandingWrapper
    class="w-full"
    :open="show"
    :data-input-error="props.error ? '' : undefined"
  >
    <div class="type-label text-red pt-1.5 font-medium" v-text="props.error" />
  </BaseExpandingWrapper>
</template>

<script setup lang="ts">
interface InputErrorProps {
  error?: string
}

const props = defineProps<InputErrorProps>()
const show = ref(false)

watch(
  () => props.error,
  async (newValue) => {
    if (newValue) {
      await nextTick()
    }

    show.value = !!newValue
  },
)
</script>
